import React, { PropTypes, Component } from 'react';
import { browserHistory } from 'react-router';
import { convertTimeSlotToString } from '../../util/sharedFunctions';

class BookingConfirmation extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        let {jobId} = this.props.routeParams;
        browserHistory.push('/booking/'.concat(jobId));

        this.props.onConfirmBooking();
    }

    closeModal(event) {
        event.preventDefault();
        this.props.actions.clearErrors();
    }

    handleCancel(event) {
        event.preventDefault();
        window.location.reload();
    }

    render() {
        const { onConfirmBooking, previousPage, booking, currentSelections } = this.props;
        
        const deliveryInfo = booking.details.deliveryInfo;
        const timeSlotDisplay = convertTimeSlotToString(currentSelections.timeslot);
        const dateDisplay = currentSelections.date.format("dddd, Do MMMM");
        const type = booking.details.isProjectUpgrade ? "upgraded" : "installed";

        let location = booking.details;

        if (deliveryInfo) {
            location = {
                name: deliveryInfo.deliveryContact,
                address: deliveryInfo.deliveryAddress,
                address2: deliveryInfo.deliveryAddress2,
                city: deliveryInfo.deliveryCity,
                postcode: deliveryInfo.deliveryPostcode,
                state: deliveryInfo.deliveryState
            };
        }

        return (
            <div>
                <h2 className="client-text">Have we got everything right?</h2>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card-slim text-center">
                            <p><i className="fa fa-map-marker" /> {deliveryInfo ? "To be delivered to:" : "To be " + type + " at:"}</p>
                            <div className="well">
                                <address>
                                    <strong>{location.name}</strong><br />
                                    {location.address}<br />
                                    {(location.address2 || "").trim() ? (
                                        <span>{location.address2}<br /></span>
                                    ) : null}
                                    {location.city}, {location.state}, {location.postcode}
                                </address>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card-slim text-center">
                            <p><i className="fa fa-calendar" /> To be {type} on:</p>
                            <div className="well">
                                <strong>{dateDisplay}</strong>
                                <br />
                                {timeSlotDisplay}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button type="button" className="btn btn-client btn-lg btn-block" onClick={onConfirmBooking}>Book</button>
                    </div>
                </div>
                <div className="row m-t-15">
                    <div className="col-xs-6">
                        <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={previousPage}>Back</button>
                    </div>
                    <div className="col-xs-6">
                        <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={this.handleCancel.bind(this)}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BookingConfirmation;


// WEBPACK FOOTER //
// ./app/booking/components/bookingWizardVerification.js